export default function StepIndicator({ step = 1 }) {
  const steps = [
    { n: 1, title: "Clinic", desc: "Create clinic + settings" },
    { n: 2, title: "Owner", desc: "Create owner user" },
    { n: 3, title: "Done", desc: "Review result" },
  ];

  return (
    <div className="mb-6">
      <div className="flex items-center">
        {steps.map((s, idx) => {
          const isActive = step === s.n;
          const isDone = step > s.n;

          return (
            <div key={s.n} className="flex items-center w-full">
              <div className="flex items-center gap-3">
                <div
                  className={[
                    "h-9 w-9 rounded-full flex items-center justify-center text-sm font-semibold border",
                    isDone
                      ? "bg-emerald-600 border-emerald-600 text-white"
                      : isActive
                      ? "bg-indigo-600 border-indigo-600 text-white"
                      : "bg-white border-slate-300 text-slate-500",
                  ].join(" ")}
                >
                  {isDone ? "✓" : s.n}
                </div>

                <div className="leading-tight">
                  <div
                    className={[
                      "text-sm font-medium",
                      isActive
                        ? "text-indigo-700"
                        : isDone
                        ? "text-emerald-700"
                        : "text-slate-600",
                    ].join(" ")}
                  >
                    {s.title}
                  </div>
                  <div className="text-xs text-slate-500">{s.desc}</div>
                </div>
              </div>

              {idx !== steps.length - 1 && (
                <div className="mx-4 h-[2px] flex-1 rounded-full bg-slate-200">
                  <div
                    className={[
                      "h-[2px] rounded-full transition-all",
                      step > s.n
                        ? "w-full bg-emerald-500"
                        : step === s.n
                        ? "w-1/2 bg-indigo-500"
                        : "w-0 bg-slate-200",
                    ].join(" ")}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
